import { render, staticRenderFns } from "./ListDriverAssignmentRequests.vue?vue&type=template&id=7f54cf2d&scoped=true&lang=pug"
import script from "./ListDriverAssignmentRequests.vue?vue&type=script&lang=js"
export * from "./ListDriverAssignmentRequests.vue?vue&type=script&lang=js"
import style0 from "./ListDriverAssignmentRequests.vue?vue&type=style&index=0&id=7f54cf2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54cf2d",
  null
  
)

export default component.exports